/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DropdownCategories_allCategories$ref = any;
type IngredientRecipeModal_allIngredients$ref = any;
type IngredientRecipeModal_allUnitMeasure$ref = any;
type RecipesPage_allRecipes$ref = any;
type StepRecipeModal_allWarnings$ref = any;
type StepRecipeModal_configConstance$ref = any;
export type queries_RecipesPage_recipes_QueryVariables = {||};
export type queries_RecipesPage_recipes_QueryResponse = {|
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +allWarnings: ?{|
    +$fragmentRefs: StepRecipeModal_allWarnings$ref
  |},
  +configConstance: ?{|
    +$fragmentRefs: StepRecipeModal_configConstance$ref
  |},
  +allIngredients: ?{|
    +$fragmentRefs: IngredientRecipeModal_allIngredients$ref
  |},
  +allUnitMeasure: ?{|
    +$fragmentRefs: IngredientRecipeModal_allUnitMeasure$ref
  |},
  +allLabel: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |},
  +$fragmentRefs: RecipesPage_allRecipes$ref,
|};
export type queries_RecipesPage_recipes_Query = {|
  variables: queries_RecipesPage_recipes_QueryVariables,
  response: queries_RecipesPage_recipes_QueryResponse,
|};
*/


/*
query queries_RecipesPage_recipes_Query {
  allCategories {
    ...DropdownCategories_allCategories
  }
  allWarnings {
    ...StepRecipeModal_allWarnings
  }
  configConstance {
    ...StepRecipeModal_configConstance
  }
  allIngredients {
    ...IngredientRecipeModal_allIngredients
  }
  allUnitMeasure {
    ...IngredientRecipeModal_allUnitMeasure
  }
  allLabel {
    edges {
      node {
        id
        name
      }
    }
  }
  ...RecipesPage_allRecipes
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {
  edges {
    node {
      description
      code
      id
    }
  }
}

fragment RecipesPage_allRecipes on Query {
  allRecipes(first: 20, orderBy: "published") {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        isTrend
        name
        category {
          id
          name
        }
        serves
        favoritedBy {
          edges {
            node {
              username
              id
            }
          }
        }
        medRatings
        totalRatings
        published
        hotKeep
        picture
        difficulty
        description
        labels {
          edges {
            node {
              id
              name
            }
          }
        }
        mediaFiles {
          edges {
            node {
              id
              mediaUrl
            }
          }
        }
        __typename
      }
      cursor
    }
  }
}

fragment StepRecipeModal_allWarnings on WarningNodeConnection {
  edges {
    node {
      id
      slugName
    }
  }
}

fragment StepRecipeModal_configConstance on ConfigConstance {
  speedLimit
  temperatureControlLimit
  temperatureDegreesMin
  temperatureDegreesMax
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LabelNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LabelNodeConnection",
  "kind": "LinkedField",
  "name": "allLabel",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "published"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_RecipesPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StepRecipeModal_allWarnings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigConstance",
        "kind": "LinkedField",
        "name": "configConstance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StepRecipeModal_configConstance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IngredientRecipeModal_allIngredients"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IngredientRecipeModal_allUnitMeasure"
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "RecipesPage_allRecipes"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_RecipesPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WarningNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WarningNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigConstance",
        "kind": "LinkedField",
        "name": "configConstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "speedLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureControlLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMax",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitMeasureNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitMeasureNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "RecipeNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTrend",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeCategoryNode",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serves",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNodeConnection",
                    "kind": "LinkedField",
                    "name": "favoritedBy",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "medRatings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRatings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "published",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hotKeep",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "difficulty",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNodeConnection",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeMediaNodeConnection",
                    "kind": "LinkedField",
                    "name": "mediaFiles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeMediaNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RecipeMediaNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mediaUrl",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allRecipes(first:20,orderBy:\"published\")"
      },
      {
        "alias": null,
        "args": (v7/*: any*/),
        "filters": [
          "name",
          "orderBy",
          "category",
          "author",
          "publicDateFrom",
          "publicDateTo",
          "isTrend"
        ],
        "handle": "connection",
        "key": "Recipes_allRecipes",
        "kind": "LinkedHandle",
        "name": "allRecipes"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_RecipesPage_recipes_Query",
    "operationKind": "query",
    "text": "query queries_RecipesPage_recipes_Query {\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  allWarnings {\n    ...StepRecipeModal_allWarnings\n  }\n  configConstance {\n    ...StepRecipeModal_configConstance\n  }\n  allIngredients {\n    ...IngredientRecipeModal_allIngredients\n  }\n  allUnitMeasure {\n    ...IngredientRecipeModal_allUnitMeasure\n  }\n  allLabel {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  ...RecipesPage_allRecipes\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {\n  edges {\n    node {\n      description\n      code\n      id\n    }\n  }\n}\n\nfragment RecipesPage_allRecipes on Query {\n  allRecipes(first: 20, orderBy: \"published\") {\n    totalCount\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        id\n        isTrend\n        name\n        category {\n          id\n          name\n        }\n        serves\n        favoritedBy {\n          edges {\n            node {\n              username\n              id\n            }\n          }\n        }\n        medRatings\n        totalRatings\n        published\n        hotKeep\n        picture\n        difficulty\n        description\n        labels {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        mediaFiles {\n          edges {\n            node {\n              id\n              mediaUrl\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment StepRecipeModal_allWarnings on WarningNodeConnection {\n  edges {\n    node {\n      id\n      slugName\n    }\n  }\n}\n\nfragment StepRecipeModal_configConstance on ConfigConstance {\n  speedLimit\n  temperatureControlLimit\n  temperatureDegreesMin\n  temperatureDegreesMax\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09ed30e9d9c746ea82795c1923003dd9';

module.exports = node;
